export default "__VITE_ASSET__Bnd0e40i__"